import React from 'react'
import './index.scss'
//api
import { api } from '../../../functions/api'
//material ui
import { Grid, Paper } from '@material-ui/core'
//custom components
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'
//other libraries
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'

const TIMEOUT = 500

@inject('internal')
@inject('translate')
@observer
export default class Monitoring extends React.Component {
  
  timeout = null
  
  constructor(props) {
    super(props)
    
    this.state = {
      emails: [],
      monitoring_interval: { value: 1, label: this.formatIntervalLabel(1) },
      monitoring_interval_options: [1, 2, 3, 4, 5].map(i => ({ value: i, label: this.formatIntervalLabel(i) })),
      reporting_since_options: [],
      reporting_since: { value: this.formatReportingLabel(8, 0), label: this.formatReportingLabel(8, 0) },
      reporting_until_options: [],
      reporting_until: { value: this.formatIntervalLabel(16, 0), label: this.formatIntervalLabel(16, 0) },
    }
  }
  
  componentWillUnmount() {
    clearTimeout(this.timeout)
  }
  
  formatIntervalLabel = (value) => {
    if (1 === value) {
      return 'každú hodinu'
    }
    if (2 <= value && 4 >= value) {
      return `každé ${value} hodiny`
    }
    if (5 <= value) {
      return `každých ${value} hodín`
    }
  }
  
  formatReportingLabel = (hod, min) => {
    hod = `0${hod}`.substr(-2)
    min = `0${min}`.substr(-2)
    return `${hod}:${min}`
  }
  
  componentDidMount() {
    const emails = toJS(this.props.internal.dataForSimpeTable.reporting_emails || []).map(item => item.trim())
    let monitoring_interval = this.props.internal.dataForSimpeTable.monitoring_interval || 1
    monitoring_interval = { value: monitoring_interval, label: this.formatIntervalLabel(monitoring_interval) }
    
    let reporting_since = this.props.internal.dataForSimpeTable.reporting_since || '08:00'
    reporting_since = {
      value: reporting_since,
      label: this.formatReportingLabel(reporting_since.split(':')[0], reporting_since.split(':')[1]),
    }
    const reporting_since_options = []
    
    for (let i = 0; i < 18; i++) {
      [0, 30].forEach(j => {
        reporting_since_options.push({ value: this.formatReportingLabel(i, j), label: this.formatReportingLabel(i, j) })
      })
    }
    reporting_since_options.push({ value: this.formatReportingLabel(18, 0), label: this.formatReportingLabel(18, 0) })
    
    let reporting_until = this.props.internal.dataForSimpeTable.reporting_until || '18:00'
    reporting_until = {
      value: reporting_until,
      label: this.formatReportingLabel(reporting_until.split(':')[0], reporting_until.split(':')[1]),
    }
    const reporting_until_options = []
    
    for (let i = 8; i < 23; i++) {
      [0, 30].forEach(j => {
        reporting_until_options.push({ value: this.formatReportingLabel(i, j), label: this.formatReportingLabel(i, j) })
      })
    }
    reporting_until_options.push({ value: this.formatReportingLabel(23, 0), label: this.formatReportingLabel(23, 0) })
    
    this.setState({
      emails: emails.map(value => ({ value, label: value })),
      monitoring_interval,
      reporting_since_options,
      reporting_since,
      reporting_until_options,
      reporting_until,
    })
  }
  
  handleChange = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.updateData()
    }, TIMEOUT)
  }
  
  validateEmails(emails) {
    return emails.filter(email => /\S+@\S+\.\S+/.test(email.value))
  }
  
  handleSelectChange = (value) => {
    this.setState({ emails: this.validateEmails(value) })
    
    this.handleChange()
  }
  
  handleIntervalChange = (monitoring_interval) => {
    this.setState({ monitoring_interval })
    this.handleChange()
  }
  
  handleReportingBoundsChange = (key, value) => {
    this.setState({ [key]: value })
    this.handleChange()
  }
  
  updateData = async () => {
    let reporting_emails = this.state.emails.map(item => item.value)
    let monitoring_interval = this.state.monitoring_interval.value
    let reporting_since = this.state.reporting_since.value
    let reporting_until = this.state.reporting_until.value
    
    let update_global_settings = await api({
      method: 'post',
      url: 'global-settings',
      authorization: this.props.internal.user.access_token,
      params: {
        reporting_emails,
        monitoring_interval,
        reporting_since,
        reporting_until,
      },
    })
    
    if (update_global_settings.success === true) {
      this.props.internal.setDataForSimpeTable(update_global_settings.data.data)
      this.props.internal.setSnackbar(update_global_settings.data.message, true)
    } else {
      let resultError = ''
      if (update_global_settings.data.data.errors) {
        for (let error in update_global_settings.data.data.errors) {
          if (/^reporting_emails/.test(error)) {
            setTimeout(() => {
              const { emails } = this.state
              emails.pop()
              this.setState({ emails })
            }, 500)
          }
          resultError += update_global_settings.data.data.errors[error] + ' '
        }
      }
      this.props.internal.setSnackbar(resultError, true)
    }
  }
  
  render() {
    return (
      <Paper className={'settings-basic'}>
        <Grid container spacing={16}>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <SelectSearch
              isMulti
              isCreatable
              onChange={this.handleSelectChange}
              options={this.state.emails}
              value={this.state.emails}
              label={this.props.translate.i18n.MODULES.SETTINGS.MONITORING_EMAILS}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <SelectSearch
              isCreatable
              onChange={this.handleIntervalChange}
              options={this.state.monitoring_interval_options}
              value={this.state.monitoring_interval}
              label={this.props.translate.i18n.MODULES.SETTINGS.MONITORING_INTERVAL}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <SelectSearch
              isCreatable
              onChange={value => this.handleReportingBoundsChange('reporting_since', value)}
              options={this.state.reporting_since_options}
              value={this.state.reporting_since}
              label={this.props.translate.i18n.MODULES.SETTINGS.REPORTING_SINCE}
            />
            <SelectSearch
              isCreatable
              onChange={value => this.handleReportingBoundsChange('reporting_until', value)}
              options={this.state.reporting_until_options}
              value={this.state.reporting_until}
              label={this.props.translate.i18n.MODULES.SETTINGS.REPORTING_UNTIL}
            />
          </Grid>
        </Grid>
      
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/settings/monitoring/index.js